import React from 'react';
import { getModelCapabilityItems } from '../utils/modelCapabilities';

function ModelCapabilityIcons({ model, className = '', hideDisabled = true, onToggle, readOnly = false }) {
  const items = getModelCapabilityItems(model)
    .filter((item) => (hideDisabled ? item.enabled : true));

  if (!items.length) return null;

  const handleClick = (key) => {
    if (!onToggle || readOnly) return;
    onToggle(key);
  };

  return (
    <span className={`model-capability-icons ${className}`.trim()}>
      {items.map((item) => (
        <span
          key={item.key}
          className={`model-capability-icon ${item.enabled ? 'enabled' : 'disabled'} ${onToggle && !readOnly ? 'toggleable' : ''}`}
          title={item.label}
          aria-label={item.label}
          onClick={() => handleClick(item.key)}
        >
          <i className={`fas ${item.icon}`} />
        </span>
      ))}
    </span>
  );
}

export default ModelCapabilityIcons;
